/**
 * @module app.core
 */

import { autoinject } from "aurelia-framework";
import { IApiActionResults, IApiCustomBatch, MethodOptions } from 'app/shared/lib/api/api-types';
import { Api } from 'app/shared/lib/essette-api';

@autoinject
export class CustomBatchService {

    ////****************** Fields and Properties ************************************////


    ////****************** Functions ************************************************////
    constructor(
        private readonly api: Api) {
    }


    ////****************** Settings *************************************************////


    ////****************** Loads ****************************************************////


    ////****************** Actions **************************************************////
    public async executeBatchCalls({ calls, progress }: IApiCustomBatch): Promise<IApiActionResults[]> {
        const batch = this.api.batch();

        for(const call of calls) {
            const action = this.api.action(call.action.toString(), call.url, call.body || {});

            if(!!call.reason) {
                action.withReason(call.reason);
            }

            switch(call.method) {
                case MethodOptions.Delete:
                    batch.delete(action);
                    break;
                case MethodOptions.Post:
                    batch.post(action);
                    break;
                case MethodOptions.Put:
                    batch.put(action);
                    break;
            }
        }
        return await this.api.execute(batch, { progress });
    }
}
